import React, { FC, ReactNode } from 'react';
import _                        from 'underscore';

import { CorvalProject, Uuid }                                 from '@src/types';
import { ProjectDetails }                                      from '../from-query/ProjectDetails';
import { EmptyCollectionMessage }                              from "../util/messaging/EmptyCollectionMessage";
import { OrganizationalUserList, OrganizationalUserListProps } from './OrganizationalUserList';


interface Props {
    projectId: Uuid,
    organizationId: Uuid,
    businessFunctions: Uuid[],
    listChildComponent: OrganizationalUserListProps['listChildComponent']
    noItemsComponent?: ReactNode,
}

const defaultProps: Props = {
    projectId:          null,
    organizationId:     null,
    businessFunctions:  [],
    listChildComponent: null,
    noItemsComponent:   <EmptyCollectionMessage/>,
};

const OrganizationUsersWithBusinessFunctions: FC<Props> = ( props ) => {

    if( !props.projectId || !props.organizationId ) return null;

    return (

        <ProjectDetails id={ props.projectId } get={ `id projectMembers{ accountId account{ id businessFunctions { id name } } }` }>

            { ( item: Partial<CorvalProject> ) => {

                let relevantBusinessFunctions = _.pluck( props.businessFunctions, 'id' ) as Uuid[],
                    applicableMembers         = item.projectMembers.filter( member => {

                        const memberAccountBusinessFunctions = _.pluck( member.account.businessFunctions, 'id' ) as Uuid[];

                        return ( _.intersection( memberAccountBusinessFunctions, relevantBusinessFunctions ).length );

                    } ),
                    applicableMemberIds       = _.pluck( applicableMembers, 'accountId' );

                return (
                    <OrganizationalUserList
                        userIds={ applicableMemberIds }
                        organizationId={ props.organizationId }
                        listChildComponent={ props.listChildComponent }
                        noItemsComponent={ props.noItemsComponent }
                    />
                );
            } }

        </ProjectDetails>
    );
};

OrganizationUsersWithBusinessFunctions.defaultProps = defaultProps;

export { OrganizationUsersWithBusinessFunctions };
